import { HTTP_INTERCEPTORS } from '@angular/common/http';

import {
  FormPostService,
  AwsApiGwInterceptor,
  WINDOW_PROVIDERS,
  WithCredentialsInterceptor,
  StateTransferService,
} from '@fcom/core';
import {
  ConfigService,
  CookieService,
  GeolocationService,
  LocationRouteCffService,
  NativeBridgeService,
  TimeAndGeoipProvider,
  TimeService,
} from '@fcom/core/services';
import { CmsLocalizationProvider } from '@fcom/core/services/language/cms-localization.provider';
import { LocalizationProvider } from '@fcom/core/services/language/localization.provider';
import { GtmService } from '@fcom/common/gtm';
import { LoginTokenInterceptor } from '@fcom/common/login/interceptors';
import {
  NavigatedPathToContentWrapperService,
  NavigationMenuService,
  BreadcrumbService,
  PageMetaService,
  ScrollService,
  HotjarService,
  SchemaService,
} from '@fcom/common/services';
import { DapiUatInterceptor } from '@fcom/core/interceptors/dapi-uat-interceptor';
import { CampaignBannerService } from '@fcom/common/services/campaign-banner/campaign-banner.service';
import { FeedbackService } from '@fcom/common/services/feedback/feedback.service';
import { DapiHeadersInterceptor } from '@fcom/core/interceptors/dapi-headers-interceptor';
import { TierBenefitService } from '@fcom/core/services/tier-benefit/tier-benefit.service';

import { ClientGtmService } from '../services/client-gtm.service';

export const INTERCEPTOR_PROVIDERS: any[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AwsApiGwInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: WithCredentialsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoginTokenInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DapiUatInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DapiHeadersInterceptor,
    multi: true,
  },
];

export const WEB_SERVICE_PROVIDERS: any[] = [
  CookieService,
  GeolocationService,
  ScrollService,
  TimeAndGeoipProvider,
  TimeService,
  { provide: GtmService, useClass: ClientGtmService },
  ...WINDOW_PROVIDERS,
];

export const COMMON_SERVICE_PROVIDERS: any[] = [
  ConfigService,
  TierBenefitService,
  FormPostService,
  LocationRouteCffService,
  NativeBridgeService,
  NavigationMenuService,
  PageMetaService,
  StateTransferService,
  BreadcrumbService,
  NavigatedPathToContentWrapperService,
  { provide: LocalizationProvider, useClass: CmsLocalizationProvider },
  CampaignBannerService,
  FeedbackService,
  HotjarService,
  SchemaService,
];
